<div id="dash-text-boxes-wrapper">
  <div class="filter-question-wrapper">
    <form class="base--form-generic" [formGroup]="filterOpenTextBoxesForm">
      <div class="more-filters-wrapper">
        <div class="form-group">
          <div class="form-row">
            <div class="form-column" *ngIf="!isOnePeriod">
              <span class="filter-by">Choose Period:</span>
              <div class="select-wrapper">
                <select class="slim" formControlName="filterSelectedPeriodValue" (change)="onChangeSelectPeriod()" value="0">
                  <option value="" selected disabled hidden>Period 1</option>
                  <option value="0" >Period 1</option>
                  <option value="1" >Period 2</option>
                </select>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
            <!-- <div class="form-column">
              <span class="filter-by">NPS filter:</span>
              <div class="select-wrapper">
                <select class="slim azure" formControlName="filterNPSValue" (change)="onChangeSelectNPSFilter()">
                  <option value="" selected disabled hidden>None</option>
                  <option *ngFor="let range of filterNPSValues" [ngValue]="range.value">
                    {{ range.label }}
                  </option>
                </select>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div> -->
            <div class="form-column">
              <span class="filter-by">NPS filter:</span>
              <div class="select-wrapper">
                <select class="slim azure" formControlName="filterNPSValue" (change)="onChangeSelectNPSFilter()">
                  <option [ngValue]="null">None</option>
                  <!-- <option value="" selected disabled hidden>None</option> -->
                  <option *ngFor="let range of filterNPSValues" [ngValue]="range.value">
                    {{ range.label }}
                  </option>
                </select>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
            <div class="form-column">
              <span class="filter-by">Aggregation filter:</span>
              <div class="select-wrapper">
                <select class="slim azure" formControlName="filterAggregationValue" (change)="onChangeSelectAggregationFilter()">
                  <option [ngValue]="null">None</option>
                  <option *ngFor="let aggregation of filterAggregationValues" [ngValue]="aggregation">
                    {{ aggregation }}
                  </option>
                </select>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filters-wrapper">
        <div class="form-group">
          <div class="form-row">
            <div class="form-column">
              <div class="form-column">
                <span class="filter-by">Filter question ID:</span>
                <div class="select-wrapper">
                  <select class="slim" formControlName="filterQuestionId" (change)="onChangeAddNewFilter()">
                    <!-- <option value="" selected disabled hidden>Question ID</option> -->
                    <!-- <option value="" [selected]="!filterQuestionId?.value">Question ID</option> -->
                    <option [ngValue]="null">Question ID</option>
                    <option *ngFor="let question of textAreaQuestions" [ngValue]="question">
                      {{ question }} - {{ getQuestionFromId(question) }}
                    </option>
                  </select>
                  <div class="select-icon slim">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group filter-container" *ngFor="let item  of selectedFiltersListForm.controls; let i = index">
          <div class="form-row">
          <div class="form-column">
            <span class="filter-by"></span>
            <div class="select-wrapper"
              [tippy] = "getLabelQuestionById(item.value.filterQuestionId)"
              [lazy]="true"
              >
              <select class="slim readonly"
                [attr.disabled]="'disabled'"
                [value]="item.value.filterQuestionId"
              >
                <option *ngFor="let question of filterQuestions" [ngValue]="question.id" [selected]="question.id === item.value.filterQuestionId">
                  {{ question.description }}
                </option>
              </select>

            </div>
            <div class="select-image-wrapper">
              <div class="image-dropdown"  >
                <div class="select-image slim readonly auto-height" >
                  <ng-container *ngIf="item.value.filterAnswerRangeStart !== null && item.value.filterAnswerRangeEnd !== null; else textImgFilter">
                    {{ item.value.filterAnswerRangeStart + '-' + item.value.filterAnswerRangeEnd }}
                  </ng-container>
                  <ng-template #textImgFilter>
                    <ng-container *ngIf="filterAnswerValue; else selectImage">
                      <ng-container *ngIf="getLabelAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId) !== ''; else imageAnswerFilter">
                        {{ getLabelAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId) }}
                      </ng-container>
                      <ng-template #imageAnswerFilter>
                        <img class="filter-answer" [src]="'https://epathoscdn.it/TEST/img/' + getImageAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId)">
                      </ng-template>
                    </ng-container>
                    <ng-template #selectImage>Select answer</ng-template>
                  </ng-template>
                </div>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>


        <div class="form-group " *ngIf="selectedFiltersListForm.value.length<3 && showFiltersListFormVisible">
          <div class="form-row">
            <div class="form-column">
              <span class="filter-by">Filter by:</span>
              <div class="select-wrapper">
                <select class="slim" formControlName="filterQuestionValue" (change)="onChangeSelectQuestion()">
                  <option value="" selected disabled hidden>Question</option>
                  <option *ngFor="let question of filterQuestions" [ngValue]="question.id">
                    {{ question.description }}
                  </option>
                </select>
                <div class="select-icon slim">
                  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>
              <div class="select-image-wrapper">
                <div class="image-dropdown" *ngIf="(filterQuestionValue?.valid)" >
                  <div class="select-image slim" (click)="showOptionsContainer = !showOptionsContainer">
                    {{filterAnswerValue? getLabelAnswerById(filterQuestionValue?.value, filterAnswerValue.value ) : ' Select answer'}}
                  </div>
                  <div class="select-icon slim">
                    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
                <div class="options-container" *ngIf="showOptionsContainer" [ngClass]="showOptionsContainer?'expanded':''">
                  <ng-container  *ngIf="filteredQuestionType === 'knob' || filteredQuestionType === 'slider'; else answerListWrapper">
                    <form class="answers-range-wrapper" [formGroup]="filterOpenTextBoxesForm">
                      <div class="answers-range">
                        <div class="interval-value">
                          Inizio intervallo:
                          <input class="form-control" type="number" formControlName="filterAnswerRangeStart">
                        </div>
                        <div class="interval-value">
                          Fine intervallo:
                          <input class="form-control" type="number" formControlName="filterAnswerRangeEnd">
                        </div>
                      </div>
                      <br>Minimo: {{ answersOptions[0].range_start }}
                      <br>Massimo: {{ answersOptions[0].range_end }}
                    </form>
                  </ng-container>
                  <ng-template #answerListWrapper>
                    <div class="answer-list-wrapper">
                      <div class="answer-list">
                        <div class="answer" [ngClass]="(filterAnswerValue?.value===(answer.id.toString()))?'selected': filterAnswerValue?.value !== '' ?'not-selected':''"  *ngFor="let answer of answersOptions" (click)="setAnswerOption(answer.id.toString())">
                          <div *ngIf="answer.urlImage; else textWrapper" class="image-wrapper" [tippy] = "answer.description">
                            <img [src]="'https://epathoscdn.it/TEST/img/'+ answer.urlImage " alt="Answer Image" loading="lazy"/>
                          </div>
                          <ng-template #textWrapper>
                            <div class="description">
                              {{ answer.description }}
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                  <div class="answer-controls">
                    <div (click)="onClickCloseOptionsContainer()" class="btn-cancel"> cancel </div>
                    <button (click)="onClickAddNewFilter()" *ngIf="selectedFiltersListForm.value.length<3" [disabled]="!validNewFilter(filteredQuestionType, answersOptions[0].range_start, answersOptions[0].range_end)" type="button" class="btn-ok" > Ok </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="error" *ngIf="filterQuestionValue?.invalid && (filterQuestionValue?.dirty ||filterQuestionValue?.touched)">
            <sup>*</sup>Please provide filter question
          </div>
        </div>
        <div class="form-group justify-content-end">
          <div class="form-row">
            <div class="form-column">
              <div class="btn-default slim"   (click)="onClickShowFiltersListForm()" *ngIf="selectedFiltersListForm.value.length<3 && selectedFiltersListForm.value.length>=1">
                <svg width="20" height="11" viewBox="0 0 20 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_509_2721)">
                    <path d="M9.65117 11.312C9.33584 11.312 9.09217 11.226 8.92017 11.054C8.74817 10.8677 8.66217 10.6168 8.66217 10.3015V6.7755H5.20067C4.89967 6.7755 4.66317 6.69667 4.49117 6.539C4.31917 6.367 4.23317 6.1305 4.23317 5.8295C4.23317 5.5285 4.31917 5.29917 4.49117 5.1415C4.66317 4.9695 4.89967 4.8835 5.20067 4.8835H8.66217V1.465C8.66217 1.14967 8.74817 0.905999 8.92017 0.733999C9.09217 0.561999 9.34301 0.476 9.67267 0.476C9.98801 0.476 10.2245 0.561999 10.3822 0.733999C10.5542 0.905999 10.6402 1.14967 10.6402 1.465V4.8835H14.1017C14.417 4.8835 14.6535 4.9695 14.8112 5.1415C14.9832 5.29917 15.0692 5.5285 15.0692 5.8295C15.0692 6.1305 14.9832 6.367 14.8112 6.539C14.6535 6.69667 14.417 6.7755 14.1017 6.7755H10.6402V10.3015C10.6402 10.6168 10.5542 10.8677 10.3822 11.054C10.2245 11.226 9.98084 11.312 9.65117 11.312Z" fill="white" />
                  </g>
                  <defs>
                    <filter id="filter0_d_509_2721" x="0.233154" y="0.476074" width="18.8359" height="18.8359" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_509_2721" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_509_2721" result="shape" />
                    </filter>
                  </defs>
                </svg> Add filter
              </div>
              <div class="btn-default slim" (click)="onClickRemoveLastFilter()" *ngIf="selectedFiltersListForm.value.length>0" >
                cancel
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="base--tpanel-periods-wrapper">
        <div class="period" [ngClass]="{'purple': filterSelectedPeriodValue?.value === '0' || filterSelectedPeriodValue?.value === ''}">
          <div class="left-col-wrapper">
            <div class="icon">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.47917 0.916667H8.25V0.6875C8.25 0.505164 8.17757 0.330295 8.04864 0.201364C7.9197 0.0724328 7.74484 0 7.5625 0V0C7.38016 0 7.2053 0.0724328 7.07636 0.201364C6.94743 0.330295 6.875 0.505164 6.875 0.6875V0.916667H4.125V0.6875C4.125 0.505164 4.05257 0.330295 3.92364 0.201364C3.7947 0.0724328 3.61984 0 3.4375 0V0C3.25516 0 3.0803 0.0724328 2.95136 0.201364C2.82243 0.330295 2.75 0.505164 2.75 0.6875V0.916667H2.52083C1.85227 0.916667 1.21108 1.18225 0.738335 1.655C0.265587 2.12775 0 2.76893 0 3.4375L0 8.47917C0 9.14773 0.265587 9.78892 0.738335 10.2617C1.21108 10.7344 1.85227 11 2.52083 11H8.47917C9.14773 11 9.78892 10.7344 10.2617 10.2617C10.7344 9.78892 11 9.14773 11 8.47917V3.4375C11 2.76893 10.7344 2.12775 10.2617 1.655C9.78892 1.18225 9.14773 0.916667 8.47917 0.916667V0.916667ZM8.47917 9.625H2.52083C2.21694 9.625 1.92549 9.50428 1.71061 9.28939C1.49572 9.07451 1.375 8.78306 1.375 8.47917V4.58333H9.625V8.47917C9.625 8.78306 9.50428 9.07451 9.28939 9.28939C9.07451 9.50428 8.78306 9.625 8.47917 9.625Z" fill="white"/>
              </svg>
            </div>
            <div class="info-wrapper">
              <div class="title">
                  PERIOD {{ isOnePeriod ? '' : '1' }}
              </div>
              <div class="dates-wrapper">
                <span>{{utils.formatDateToString(periodOneStartDate)}}</span>
                <span>{{utils.formatDateToString(periodOneEndDate)}}</span>
              </div>
            </div>
          </div>
          <div class="right-col-wrapper">
            <div class="top-wrapper">
              <span>Total <br> respondents</span>
            </div>
            <div class="bottom-wrapper">
              <span>{{this.periodsCounters.completed[0]}}</span>
            </div>
          </div>
        </div>
        <div class="period" [ngClass]="{'azure': filterSelectedPeriodValue?.value === '1'}" *ngIf="!isOnePeriod">
          <div class="left-col-wrapper">
            <div class="icon">
              <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.47917 0.916667H8.25V0.6875C8.25 0.505164 8.17757 0.330295 8.04864 0.201364C7.9197 0.0724328 7.74484 0 7.5625 0V0C7.38016 0 7.2053 0.0724328 7.07636 0.201364C6.94743 0.330295 6.875 0.505164 6.875 0.6875V0.916667H4.125V0.6875C4.125 0.505164 4.05257 0.330295 3.92364 0.201364C3.7947 0.0724328 3.61984 0 3.4375 0V0C3.25516 0 3.0803 0.0724328 2.95136 0.201364C2.82243 0.330295 2.75 0.505164 2.75 0.6875V0.916667H2.52083C1.85227 0.916667 1.21108 1.18225 0.738335 1.655C0.265587 2.12775 0 2.76893 0 3.4375L0 8.47917C0 9.14773 0.265587 9.78892 0.738335 10.2617C1.21108 10.7344 1.85227 11 2.52083 11H8.47917C9.14773 11 9.78892 10.7344 10.2617 10.2617C10.7344 9.78892 11 9.14773 11 8.47917V3.4375C11 2.76893 10.7344 2.12775 10.2617 1.655C9.78892 1.18225 9.14773 0.916667 8.47917 0.916667V0.916667ZM8.47917 9.625H2.52083C2.21694 9.625 1.92549 9.50428 1.71061 9.28939C1.49572 9.07451 1.375 8.78306 1.375 8.47917V4.58333H9.625V8.47917C9.625 8.78306 9.50428 9.07451 9.28939 9.28939C9.07451 9.50428 8.78306 9.625 8.47917 9.625Z" fill="white"/>
              </svg>
            </div>
            <div class="info-wrapper">
              <div class="title">
                  PERIOD 2
              </div>
              <div class="dates-wrapper">
                <span>{{utils.formatDateToString(periodTwoStartDate)}}</span>
                <span>{{utils.formatDateToString(periodTwoEndDate)}}</span>
              </div>
            </div>
          </div>
          <div class="right-col-wrapper">
            <div class="top-wrapper">
              <span>Total <br> respondents</span>
            </div>
            <div class="bottom-wrapper">
              <span>{{this.periodsCounters.completed[1]}}</span>
            </div>
          </div>
        </div>
      </div> -->

      <div class="base--tpanel-periods-wrapper" style="align-items: end;">
        <!-- <div class="period" [ngClass]="{'purple': filterSelectedPeriodValue?.value === '0' || filterSelectedPeriodValue?.value === ''}"> -->
        <div class="period purple">
          <div class="left-col-wrapper">
            <div class="info-wrapper">
              <div class="title">
                <div class="icon">
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.47917 0.916667H8.25V0.6875C8.25 0.505164 8.17757 0.330295 8.04864 0.201364C7.9197 0.0724328 7.74484 0 7.5625 0V0C7.38016 0 7.2053 0.0724328 7.07636 0.201364C6.94743 0.330295 6.875 0.505164 6.875 0.6875V0.916667H4.125V0.6875C4.125 0.505164 4.05257 0.330295 3.92364 0.201364C3.7947 0.0724328 3.61984 0 3.4375 0V0C3.25516 0 3.0803 0.0724328 2.95136 0.201364C2.82243 0.330295 2.75 0.505164 2.75 0.6875V0.916667H2.52083C1.85227 0.916667 1.21108 1.18225 0.738335 1.655C0.265587 2.12775 0 2.76893 0 3.4375L0 8.47917C0 9.14773 0.265587 9.78892 0.738335 10.2617C1.21108 10.7344 1.85227 11 2.52083 11H8.47917C9.14773 11 9.78892 10.7344 10.2617 10.2617C10.7344 9.78892 11 9.14773 11 8.47917V3.4375C11 2.76893 10.7344 2.12775 10.2617 1.655C9.78892 1.18225 9.14773 0.916667 8.47917 0.916667V0.916667ZM8.47917 9.625H2.52083C2.21694 9.625 1.92549 9.50428 1.71061 9.28939C1.49572 9.07451 1.375 8.78306 1.375 8.47917V4.58333H9.625V8.47917C9.625 8.78306 9.50428 9.07451 9.28939 9.28939C9.07451 9.50428 8.78306 9.625 8.47917 9.625Z" fill="white"/>
                  </svg>
                </div>
                <div class="testo">PERIOD {{ isOnePeriod ? '' : '1' }}</div>
              </div>
              <div class="dates-wrapper">
                {{utils.formatDateToString(periodOneStartDate)}} - {{utils.formatDateToString(periodOneEndDate)}}
              </div>
            </div>
          </div>
          <div class="left-col-wrapper">
            <div class="info-wrapper">
              <div class="title">
                <div>Total respondents</div>
              </div>
              <div class="dates-wrapper">
                {{this.periodsCounters.completed[0]}}
              </div>
            </div>
          </div>
        </div>
        <div class="period azure" *ngIf="!isOnePeriod">
          <div class="left-col-wrapper">
            <div class="info-wrapper">
              <div class="title">
                <div class="icon">
                  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.47917 0.916667H8.25V0.6875C8.25 0.505164 8.17757 0.330295 8.04864 0.201364C7.9197 0.0724328 7.74484 0 7.5625 0V0C7.38016 0 7.2053 0.0724328 7.07636 0.201364C6.94743 0.330295 6.875 0.505164 6.875 0.6875V0.916667H4.125V0.6875C4.125 0.505164 4.05257 0.330295 3.92364 0.201364C3.7947 0.0724328 3.61984 0 3.4375 0V0C3.25516 0 3.0803 0.0724328 2.95136 0.201364C2.82243 0.330295 2.75 0.505164 2.75 0.6875V0.916667H2.52083C1.85227 0.916667 1.21108 1.18225 0.738335 1.655C0.265587 2.12775 0 2.76893 0 3.4375L0 8.47917C0 9.14773 0.265587 9.78892 0.738335 10.2617C1.21108 10.7344 1.85227 11 2.52083 11H8.47917C9.14773 11 9.78892 10.7344 10.2617 10.2617C10.7344 9.78892 11 9.14773 11 8.47917V3.4375C11 2.76893 10.7344 2.12775 10.2617 1.655C9.78892 1.18225 9.14773 0.916667 8.47917 0.916667V0.916667ZM8.47917 9.625H2.52083C2.21694 9.625 1.92549 9.50428 1.71061 9.28939C1.49572 9.07451 1.375 8.78306 1.375 8.47917V4.58333H9.625V8.47917C9.625 8.78306 9.50428 9.07451 9.28939 9.28939C9.07451 9.50428 8.78306 9.625 8.47917 9.625Z" fill="white"/>
                  </svg>
                </div>
                <div class="testo">PERIOD 2</div>
              </div>
              <div class="dates-wrapper">
                {{utils.formatDateToString(periodTwoStartDate)}} - {{utils.formatDateToString(periodTwoEndDate)}}
              </div>
            </div>
          </div>

          <div class="left-col-wrapper">
            <div class="info-wrapper">
              <div class="title">
                <div>Total respondents</div>
              </div>
              <div class="dates-wrapper">
                {{this.periodsCounters.completed[1]}}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fields-wrapper justify-content-end">
        <div class="form-group">
          <div class="form-row align-items-center">
            <div class="form-column">
              <div class="export-wrapper" (click)="onClickDownloadImage()">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M3 17C3 16.7348 3.10536 16.4804 3.29289 16.2929C3.48043 16.1054 3.73478 16 4 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18H4C3.73478 18 3.48043 17.8946 3.29289 17.7071C3.10536 17.5196 3 17.2652 3 17ZM6.293 9.293C6.48053 9.10553 6.73484 9.00021 7 9.00021C7.26516 9.00021 7.51947 9.10553 7.707 9.293L9 10.586V3C9 2.73478 9.10536 2.48043 9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V10.586L12.293 9.293C12.3852 9.19749 12.4956 9.12131 12.6176 9.0689C12.7396 9.01649 12.8708 8.9889 13.0036 8.98775C13.1364 8.9866 13.2681 9.0119 13.391 9.06218C13.5139 9.11246 13.6255 9.18671 13.7194 9.28061C13.8133 9.3745 13.8875 9.48615 13.9378 9.60905C13.9881 9.73194 14.0134 9.86362 14.0123 9.9964C14.0111 10.1292 13.9835 10.2604 13.9311 10.3824C13.8787 10.5044 13.8025 10.6148 13.707 10.707L10.707 13.707C10.5195 13.8945 10.2652 13.9998 10 13.9998C9.73484 13.9998 9.48053 13.8945 9.293 13.707L6.293 10.707C6.10553 10.5195 6.00021 10.2652 6.00021 10C6.00021 9.73484 6.10553 9.48053 6.293 9.293V9.293Z" fill="#533B83"/>
                </svg>
                <span>
                  Export
                </span>
              </div>
            </div>
            <div class="form-column">
              <div class="btn-default slim white" (click)="toggleAiRecap()" >
                {{ showAiRecap ? 'Hide AI summary' : 'Show AI summary' }}
              </div>
            </div>
            <div class="form-column">
              <div class="btn-default slim purple" (click)="toggleModalKeys()" >
                Show survey
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ai-container" *ngIf="showAiRecap">
        <form class="ai-recap">
          <div class="ai-header">
            <h3>What emerges from customer opinions - AI</h3>
            <!-- <button (click)="aiReload()" class="reload-ai">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                <path d="M6 12.5C4.325 12.5 2.90625 11.9187 1.74375 10.7562C0.58125 9.59375 0 8.175 0 6.5C0 4.825 0.58125 3.40625 1.74375 2.24375C2.90625 1.08125 4.325 0.500003 6 0.500003C6.8625 0.500003 7.6875 0.678002 8.475 1.034C9.2625 1.39 9.9375 1.8995 10.5 2.5625V1.25C10.5 1.0375 10.572 0.859503 10.716 0.716003C10.86 0.572503 11.038 0.500503 11.25 0.500003C11.462 0.499503 11.6402 0.571503 11.7847 0.716003C11.9292 0.860503 12.001 1.0385 12 1.25V5C12 5.2125 11.928 5.39075 11.784 5.53475C11.64 5.67875 11.462 5.7505 11.25 5.75H7.5C7.2875 5.75 7.1095 5.678 6.966 5.534C6.8225 5.39 6.7505 5.212 6.75 5C6.7495 4.788 6.8215 4.61 6.966 4.466C7.1105 4.322 7.2885 4.25 7.5 4.25H9.9C9.5 3.55 8.95325 3 8.25975 2.6C7.56625 2.2 6.813 2 6 2C4.75 2 3.6875 2.4375 2.8125 3.3125C1.9375 4.1875 1.5 5.25 1.5 6.5C1.5 7.75 1.9375 8.8125 2.8125 9.6875C3.6875 10.5625 4.75 11 6 11C6.85 11 7.62825 10.7845 8.33475 10.3535C9.04125 9.9225 9.588 9.34425 9.975 8.61875C10.075 8.44375 10.2157 8.322 10.3972 8.2535C10.5787 8.185 10.763 8.18175 10.95 8.24375C11.15 8.30625 11.2937 8.4375 11.3812 8.6375C11.4687 8.8375 11.4625 9.025 11.3625 9.2C10.85 10.2 10.1187 11 9.16875 11.6C8.21875 12.2 7.1625 12.5 6 12.5Z" fill="#533B83"/>
              </svg>
              Refresh AI
            </button>
            <button class="btn-info" (click)="setShowRefreshAiModal(true)">i</button> -->
            <button class="export-wrapper" style="margin-left: auto;" (click)="onClickExportAiSummary()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 17C3 16.7348 3.10536 16.4804 3.29289 16.2929C3.48043 16.1054 3.73478 16 4 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18H4C3.73478 18 3.48043 17.8946 3.29289 17.7071C3.10536 17.5196 3 17.2652 3 17ZM6.293 9.293C6.48053 9.10553 6.73484 9.00021 7 9.00021C7.26516 9.00021 7.51947 9.10553 7.707 9.293L9 10.586V3C9 2.73478 9.10536 2.48043 9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V10.586L12.293 9.293C12.3852 9.19749 12.4956 9.12131 12.6176 9.0689C12.7396 9.01649 12.8708 8.9889 13.0036 8.98775C13.1364 8.9866 13.2681 9.0119 13.391 9.06218C13.5139 9.11246 13.6255 9.18671 13.7194 9.28061C13.8133 9.3745 13.8875 9.48615 13.9378 9.60905C13.9881 9.73194 14.0134 9.86362 14.0123 9.9964C14.0111 10.1292 13.9835 10.2604 13.9311 10.3824C13.8787 10.5044 13.8025 10.6148 13.707 10.707L10.707 13.707C10.5195 13.8945 10.2652 13.9998 10 13.9998C9.73484 13.9998 9.48053 13.8945 9.293 13.707L6.293 10.707C6.10553 10.5195 6.00021 10.2652 6.00021 10C6.00021 9.73484 6.10553 9.48053 6.293 9.293V9.293Z" fill="#533B83"/>
              </svg>
              <span>
                Export
              </span>
            </button>
          </div>
          <div class="applied-filters-wrapper">
            <table class="applied-filters">
              <tbody>
                <tr *ngIf="hasReloadedAi">
                  <td>Period</td>
                  <td>{{ utils.formatDateToString(getCurrentPeriod().startDate) }} - {{ utils.formatDateToString(getCurrentPeriod().endDate) }}</td>
                </tr>
                <tr *ngIf="filterOpenTextBoxesForm.controls.filterNPSValue.value">
                  <td>NPS filter</td>
                  <td>{{ filterOpenTextBoxesForm.controls.filterNPSValue.value | titlecase }}</td>
                </tr>
                <tr *ngIf="filterOpenTextBoxesForm.controls.filterAggregationValue.value">
                  <td>Aggregation filter</td>
                  <td>{{ filterOpenTextBoxesForm.controls.filterAggregationValue.value }}</td>
                </tr>
                <tr *ngIf="filterOpenTextBoxesForm.controls.filterQuestionId.value">
                  <td>Filter question ID</td>
                  <td>{{ filterOpenTextBoxesForm.controls.filterQuestionId.value }} - {{ getQuestionFromId(filterOpenTextBoxesForm.controls.filterQuestionId.value) }}</td>
                </tr>
                <tr *ngFor="let item of selectedFiltersListForm.controls; let i = index">
                  <td>Filter {{ i + 1 }}</td>
                  <td>
                    {{ getLabelQuestionById(item.value.filterQuestionId) }}
                    <b>
                      <ng-container *ngIf="item.value.filterAnswerRangeStart !== null && item.value.filterAnswerRangeEnd !== null; else textImgFilterRecap">
                        {{ item.value.filterAnswerRangeStart + '-' + item.value.filterAnswerRangeEnd }}
                      </ng-container>
                      <ng-template #textImgFilterRecap>
                        <ng-container *ngIf="filterAnswerValue">
                          <ng-container *ngIf="getLabelAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId) !== ''; else imageAnswerFilter">
                            {{ getLabelAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId) }}
                          </ng-container>
                          <ng-template #imageAnswerFilter>
                            <img class="filter-answer" [src]="'https://epathoscdn.it/TEST/img/' + getImageAnswerById(item?.value?.filterQuestionId, item?.value?.filterAnswerId)">
                          </ng-template>
                        </ng-container>
                      </ng-template>
                    </b>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <div class="select-wrapper">
              <select class="slim" [formControl]="aiSelectedQuestion">
                <option [ngValue]="null">Question ID</option>
                <option *ngFor="let question of textAreaQuestions" [ngValue]="question">
                  {{ question }} - {{ getQuestionFromId(question) }}
                </option>
              </select>
              <div class="select-icon slim">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
          </div>
          <ng-container *ngIf="getAiRecapFromQuestion()">
            <p class="mt-3">{{ getAiRecapFromQuestion().riassunto }}</p>
            <p class="subtle">Generated by AI from the text</p>
          </ng-container>
        </form>

        <div class="ai-accordion">
          <button (click)="toggleAccordionFindings()">
            Key findings
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="{'rotate-180': showAccordionFindings}">
              <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#374957" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <div class="key-findings" *ngIf="showAccordionFindings" >
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Themes</th>
                    <th>Comment</th>
                    <th>Frequency</th>
                    <th>Action Recommendation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let thematic of getAiThematicsFromQuestion()">
                    <td><b>{{ thematic.tema_principale | formatAiTheme | titlecase }}</b></td>
                    <td>
                      {{ thematic.riassunto }}
                      <ng-container *ngIf="thematic.esempi && thematic.esempi.length">
                        <br>Examples:
                        <ul>
                          <li *ngFor="let example of thematic.esempi">{{ example }}</li>
                        </ul>
                      </ng-container>
                    </td>
                    <td>{{ thematic.frequenza }}</td>
                    <td>{{ thematic.tono ? (thematic.tono | translateTone) : '' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="ai-accordion">
          <button (click)="toggleAccordionCloud()">
            Word cloud
            <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="{'rotate-180': showAccordionCloud}">
              <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#374957" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <ng-container *ngIf="showAccordionCloud" >
            <angular-tag-cloud
              [data]="cloudData"
              [width]="cloudOptions.width"
              [height]="cloudOptions.height"
              [overflow]="cloudOptions.overflow">
            </angular-tag-cloud>
          </ng-container>
        </div>
      </div>

      <div class="row p-0">
        <tr class="text-boxes-chart-wrapper col-12">
          <table *ngIf="this.openTextBoxesAnswers$?.length > 0">
            <tr>
              <th>
                Id Question
              </th>

              <th>
                  SUGGESTION<br/>
                  SCORE
              </th>
              <th>
                SATISFACTION<br/>
                SCORE
              </th>
              <th>
                TOUCHPOINT
              </th>
              <th>
                <div class="d-flex align-items-center justify-content-center">
                  EMOTION
                  <button class="btn-emotions-summary" (click)="setShowEmotionsSummary(true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                      <circle cx="9.50003" cy="9.08993" r="8.49185" stroke="#212529" stroke-width="1.01623"/>
                      <path d="M5.05402 8.98866C5.05402 8.52282 5.05402 8.29015 5.19875 8.14541C5.34349 8.00067 5.57616 8.00067 6.04199 8.00067C6.50783 8.00067 6.74049 8.00067 6.88523 8.14541C7.02997 8.29015 7.02997 8.52282 7.02997 8.98866V11.9526C7.02997 12.4184 7.02997 12.6511 6.88523 12.7959C6.74049 12.9406 6.50783 12.9406 6.04199 12.9406C5.57616 12.9406 5.34349 12.9406 5.19875 12.7959C5.05402 12.6511 5.05402 12.4184 5.05402 11.9526V8.98866ZM8.51194 7.01269C8.51194 6.54685 8.51194 6.31418 8.65668 6.16944C8.80142 6.0247 9.03408 6.0247 9.49992 6.0247C9.96575 6.0247 10.1984 6.0247 10.3432 6.16944C10.4879 6.31418 10.4879 6.54685 10.4879 7.01269V11.9526C10.4879 12.4184 10.4879 12.6511 10.3432 12.7959C10.1984 12.9406 9.96575 12.9406 9.49992 12.9406C9.03408 12.9406 8.80142 12.9406 8.65668 12.7959C8.51194 12.6511 8.51194 12.4184 8.51194 11.9526V7.01269ZM11.9699 5.53071C11.9699 5.06487 11.9699 4.8322 12.1146 4.68746C12.2593 4.54272 12.492 4.54272 12.9578 4.54272C13.4237 4.54272 13.6563 4.54272 13.8011 4.68746C13.9458 4.8322 13.9458 5.06487 13.9458 5.53071V11.9526C13.9458 12.4184 13.9458 12.6511 13.8011 12.7959C13.6563 12.9406 13.4237 12.9406 12.9578 12.9406C12.492 12.9406 12.2593 12.9406 12.1146 12.7959C11.9699 12.6511 11.9699 12.4184 11.9699 11.9526V5.53071Z" fill="#212529"/>
                    </svg>
                  </button>
                  <button class="btn-emotions-summary" (click)="setShowFilterEmotions(true)">
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.50002 13.5C8.35835 13.5 8.23968 13.452 8.14402 13.356C8.04835 13.26 8.00035 13.1413 8.00002 13V10L5.10001 6.3C4.97501 6.13333 4.95635 5.95833 5.04401 5.775C5.13168 5.59167 5.28368 5.5 5.50001 5.5H12.5C12.7167 5.5 12.8688 5.59167 12.9565 5.775C13.0442 5.95833 13.0253 6.13333 12.9 6.3L10 10V13C10 13.1417 9.95201 13.2605 9.85601 13.3565C9.76001 13.4525 9.64135 13.5003 9.50001 13.5H8.50002Z" fill="#212529"/>
                      <circle cx="9.00003" cy="9.08969" r="8.49185" stroke="#212529" stroke-width="1.01623"/>
                    </svg>
                  </button>
                </div>
              </th>
              <th>
                <div class="d-flex align-items-center justify-content-center">
                  CONFIDENCE
                  <button class="btn-emotions-summary" (click)="setShowFilterConfidence(true)">
                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.50002 13.5C8.35835 13.5 8.23968 13.452 8.14402 13.356C8.04835 13.26 8.00035 13.1413 8.00002 13V10L5.10001 6.3C4.97501 6.13333 4.95635 5.95833 5.04401 5.775C5.13168 5.59167 5.28368 5.5 5.50001 5.5H12.5C12.7167 5.5 12.8688 5.59167 12.9565 5.775C13.0442 5.95833 13.0253 6.13333 12.9 6.3L10 10V13C10 13.1417 9.95201 13.2605 9.85601 13.3565C9.76001 13.4525 9.64135 13.5003 9.50001 13.5H8.50002Z" fill="#212529"/>
                      <circle cx="9.00003" cy="9.08969" r="8.49185" stroke="#212529" stroke-width="1.01623"/>
                    </svg>
                  </button>
                </div>
              </th>
              <th *ngFor="let filter of selectedFiltersListForm.controls; let i = index">
                FILTER {{i + 1}}
              </th>
              <th>
                COMMENT
              </th>
            </tr>
            <tr class="" *ngFor="let answer of this.openTextBoxesAnswers$; let i = index">
              <td> <span [tippy]="getQuestionFromId(answer.domanda_id)">{{answer.domanda_id}}</span></td>
              <td>
                <div *ngIf="answer.nps?.risposta !== null; else elseNullImage">
                  <ng-container *ngIf="isNumeric(answer.nps?.risposta); else npsImage">
                    <div class="answer nps">{{ answer.nps?.risposta }}</div>
                  </ng-container>
                  <ng-template #npsImage>
                    <img [src]="'https://epathoscdn.it/TEST/img/'+ answer.nps?.risposta"  [tippy] = "answer.nps?.testo_risposta"  alt="Answer Image" loading="lazy"/>
                  </ng-template>
                </div>
                <ng-template #elseNullImage>
                  <div>
                    <div class="empty-image-box">
                    </div>
                  </div>
                </ng-template>
              </td>
              <td>
                 <div *ngIf="answer.satisfaction?.risposta !== null; else elseNullImage">
                  <ng-container *ngIf="isNumeric(answer.satisfaction?.risposta); else satisfactionImage">
                    <div class="answer satisfaction">{{ answer.satisfaction?.risposta }}</div>
                  </ng-container>
                  <ng-template #satisfactionImage>
                    <img [src]="'https://epathoscdn.it/TEST/img/'+ answer.satisfaction?.risposta"  [tippy] = "answer.satisfaction?.testo_risposta"  alt="Answer Image" loading="lazy"/>
                  </ng-template>
                </div>
                <ng-template #elseNullImage>
                  <div>
                    <div class="empty-image-box">
                    </div>
                  </div>
                </ng-template>
              </td>
              <td> {{answer.touch_point}}</td>
              <td class="emotion {{ answer.emotion | lowercase}}">
                <ng-container *ngIf="editQuestionEmotion.controls.event_id.value === answer.event_id; else showEmotion">
                  <form [formGroup]="editQuestionEmotion" (submit)="onSubmitEditEmotion()" class="base--form-generic">
                    <div class="form-group">
                      <div class="select-wrapper">
                        <select class="slim" formControlName="emotion">
                          <option *ngFor="let emotion of emotions" [ngValue]="emotion">
                            {{ emotion | translateEmotion | titlecase }}
                          </option>
                          <option value="non risposta">No-answer</option>
                        </select>
                        <div class="select-icon slim">
                          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div class="edit-actions form-group">
                      <button type="button" class="btn-default slim white" (click)="closeEditEmotionForm()">Cancel</button>
                      <button type="submit" class="btn-default slim purple">Save</button>
                    </div>
                  </form>
                </ng-container>
                <ng-template #showEmotion>
                  {{ answer.emotion ? (answer.emotion | translateEmotion | titlecase) : 'N/A' }}
                  <button class="btn-edit-emotion" (click)="showEditEmotionForm(answer.event_id, answer.emotion)" title="Edit">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-fill" viewBox="0 0 16 16">
                      <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                    </svg>
                  </button>
                </ng-template>
              </td>
              <td>
                {{ answer.sicurezza ? answer.sicurezza : 'N/A' }}
              </td>
              <td *ngFor="let filter of selectedFiltersListForm.controls; let i = index">
                <div *ngIf="getValueOfFilterAnswer(answer.answers_filter, filter.value.filterQuestionId) !== null; else elseNullImage">
                  <img [src]="'https://epathoscdn.it/TEST/img/'+ getValueOfFilterAnswer(answer.answers_filter, filter.value.filterQuestionId)"  [tippy] = "answer.testo_risposta"  alt="Answer Image" loading="lazy"/>
                </div>
                <ng-template #elseNullImage>
                  <div>
                    <div class="empty-image-box">
                    </div>
                  </div>
                </ng-template>
              </td>
              <td> <p>
                {{(answer.showMore) ? answer.risposta : (answer.risposta | slice:0:130)}} <span *ngIf="!answer.showMore && (answer.risposta.length > 130)">...</span>
                <a href="javascript:;" *ngIf="!answer.showMore && (answer.risposta.length > 130) " (click)="answer.showMore=true">[Read more]</a>

              </p></td>
            </tr>
          </table>
          <div *ngIf="this.openTextBoxesAnswers$?.length > 0" class="form-actions d-flex justify-content-center m-5">
            <button class="btn-next" (click)="showMoreItems()">
              Show More
            </button>
          </div>
          <div style="display: flex; justify-content: center;" *ngIf="this.openTextBoxesAnswers$?.length === 0">
            <h3>Not comments found</h3>
          </div>
        </div>
    </form>
  </div>

  <ng-container *ngIf="showEmotionsSummary">
    <div class="modal-emotions">
      <section>
        <button class="modal-close" type="button" (click)="setShowEmotionsSummary(false)">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M2.00012 2L23.0001 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
            <path d="M23.0001 2L2.00012 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
          </svg>
        </button>
        <button class="export-wrapper" (click)="onClickDownloadEmotions()">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M3 17C3 16.7348 3.10536 16.4804 3.29289 16.2929C3.48043 16.1054 3.73478 16 4 16H16C16.2652 16 16.5196 16.1054 16.7071 16.2929C16.8946 16.4804 17 16.7348 17 17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18H4C3.73478 18 3.48043 17.8946 3.29289 17.7071C3.10536 17.5196 3 17.2652 3 17ZM6.293 9.293C6.48053 9.10553 6.73484 9.00021 7 9.00021C7.26516 9.00021 7.51947 9.10553 7.707 9.293L9 10.586V3C9 2.73478 9.10536 2.48043 9.29289 2.29289C9.48043 2.10536 9.73478 2 10 2C10.2652 2 10.5196 2.10536 10.7071 2.29289C10.8946 2.48043 11 2.73478 11 3V10.586L12.293 9.293C12.3852 9.19749 12.4956 9.12131 12.6176 9.0689C12.7396 9.01649 12.8708 8.9889 13.0036 8.98775C13.1364 8.9866 13.2681 9.0119 13.391 9.06218C13.5139 9.11246 13.6255 9.18671 13.7194 9.28061C13.8133 9.3745 13.8875 9.48615 13.9378 9.60905C13.9881 9.73194 14.0134 9.86362 14.0123 9.9964C14.0111 10.1292 13.9835 10.2604 13.9311 10.3824C13.8787 10.5044 13.8025 10.6148 13.707 10.707L10.707 13.707C10.5195 13.8945 10.2652 13.9998 10 13.9998C9.73484 13.9998 9.48053 13.8945 9.293 13.707L6.293 10.707C6.10553 10.5195 6.00021 10.2652 6.00021 10C6.00021 9.73484 6.10553 9.48053 6.293 9.293V9.293Z" fill="#533B83"/>
          </svg>
          <span>
            Export
          </span>
        </button>
        <div class="row" id="export-emotions">
          <div class="title">
            Gut Feeling<span *ngIf="filterOpenTextBoxesForm.controls.filterQuestionId.value">: {{ filterOpenTextBoxesForm.controls.filterQuestionId.value }} - {{ getQuestionFromId(filterOpenTextBoxesForm.controls.filterQuestionId.value) }}</span>
          </div>
          <div class="col-md-6" style="align-content: center;">
            <div echarts [options]="chartEmotionsOption"></div>
          </div>
          <div class="col-md-6">
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Emotions</th>
                    <th>Percentage</th>
                    <th>Absolute value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let emotion of emotionsSummary">
                    <td><b>{{ emotion.emotion === "N/A" || emotion.emotion === "Indefinibile" || emotion.emotion === "Non risposta" ? (emotion.emotion | translateEmotion) : (emotion.emotion | translateEmotion | titlecase) }}</b></td>
                    <td><b>{{ emotion.emotion === "N/A" || emotion.emotion === "Indefinibile" || emotion.emotion === "Non risposta" ? "--" : (emotion.count / emotionsTotalCount * 100 | number : '1.2-2') + "%" }}</b></td>
                    <td>{{ emotion.count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="subtle">N/A means that not enough words were used</div>
          </div>
        </div>
      </section>
    </div>
  </ng-container>

  <ng-container *ngIf="showRefreshAiModal">
    <div class="modal-refresh-info">
      <section>
        <button class="modal-close" type="button" (click)="setShowRefreshAiModal(false)">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M2.00012 2L23.0001 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
            <path d="M23.0001 2L2.00012 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
          </svg>
        </button>
        <p><b>Click to update AI results based on the period and filters applied.</b></p>
      </section>
    </div>
  </ng-container>

  <ng-container *ngIf="showFilterEmotions">
    <div class="modal-refresh-info small">
      <section>
        <button class="modal-close right" type="button" (click)="setShowFilterEmotions(false)" >
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M2.00012 2L23.0001 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
            <path d="M23.0001 2L2.00012 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
          </svg>
        </button>
        <form (submit)="submitFilterByEmotion()" class="base--form-generic">
          <h3>Filter by emotion</h3>
          <div class="form-group">
            <div class="select-wrapper">
              <select [formControl]="filteredEmotion" class="slim">
                <option *ngFor="let emotion of emotions" [ngValue]="emotion">
                  {{ emotion | translateEmotion | titlecase }}
                </option>
                <option value="non risposta">No-answer</option>
                <option value="N/A">N/A</option>
              </select>
              <div class="select-icon slim">
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1.04547L5 4.98486L9 1.04547" stroke="#A8AAB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>
            <button type="button" class="btn-default slim white" *ngIf="filteredEmotion.value !== ''" (click)="resetFilteredEmotion()">Reset</button>
            <button type="submit" class="btn-default slim purple">OK</button>
          </div>
        </form>
      </section>
    </div>
  </ng-container>

  <ng-container *ngIf="showFilterConfidence">
    <div class="modal-refresh-info small">
      <section>
        <button class="modal-close right" type="button" (click)="setShowFilterConfidence(false)" >
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M2.00012 2L23.0001 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
            <path d="M23.0001 2L2.00012 23" stroke="#533B83" stroke-width="2.12133" stroke-linecap="round"/>
          </svg>
        </button>
        <form (submit)="submitFilterByConfidence()" [formGroup]="filteredConfidence" class="base--form-generic">
          <h3>Filter by emotion confidence</h3>
          <div class="form-group justify-content-between">
            <div class="range-wrapper">
              <span>From</span>
              <div class="input-wrapper">
                <input type="number" formControlName="min" min="0" max="100">
              </div>
              <span>to</span>
              <div class="input-wrapper">
                <input type="number" formControlName="max" min="0" max="100">
              </div>
            </div>
            <button type="button" class="btn-default slim white" style="margin-left: auto;" *ngIf="filteredConfidence.controls.min.value !== 0 || filteredConfidence.controls.max.value !== 100" (click)="resetFilteredConfidence()">Reset</button>
            <button type="submit" class="btn-default slim purple">OK</button>
          </div>
        </form>
      </section>
    </div>
  </ng-container>
</div>
